<template>
  <div class="plr-suggestions bounce permanent">
    <ul class="plr-animated-buttons">
      <li v-for="(v, i) in suggestions" :key="i">
        <button @click="handleClick(v)" type="button">{{ v }}</button>
      </li>
    </ul>
  </div>
</template>
<script lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";
import { MessageType } from "@moderrotech/servers-communication-library/src/types";

export default {
  setup() {
    const store = useStore();

    return {
      suggestions: computed((): string[] => store.state.session.suggestions),
      handleClick: (text: string) =>
        store.dispatch("session/sendJsonMessage", {
          message: {
            type: MessageType.suggestionClick,
            item: text
          }
        })
    };
  }
};
</script>

<style lang="scss">
@import "../assets/styles/suggestions.scss";
@import "../assets/styles/kiosk-landscape-30inch/suggestions.scss";
@import "../assets/styles/kiosk-portrait-30inch/suggestions.scss";
</style>
